import React, { useEffect } from "react";
import ReactGA from "react-ga4";

import preAssembleia from "../../../assets/landingpage/unicred/pre-assembleia.png";
import iconDownload from "../../../assets/landingpage/unicred/download.png";
import iconInstagram from "../../../assets/landingpage/unicred/instagram.png";
import iconFacebook from "../../../assets/landingpage/unicred/facebook.png";
import iconTwitter from "../../../assets/landingpage/unicred/twitter.png";
import iconYoutube from "../../../assets/landingpage/unicred/youtube.png";
import iconLinkedin from "../../../assets/landingpage/unicred/linkedin.png";
import unicredLogo from "../../../assets/landingpage/unicred/unicred.png";

import "./styles.scss";

function UnicredDesbravadora({ domain }) {
  useEffect(() => {
    ReactGA.send({
      hitType: "event",
      eventCategory: "landingPage",
      eventAction: "access",
      eventLabel: domain,
    });
  }, []);

  return (
    <div className="lp-unicred">
      <div className="section-1">
        <div className="section-1-container wrap">
          <div className="section-1-image">
            <div className="section-1-position">
              <img src={preAssembleia} />
            </div>
          </div>
          <div className="section-1-info section-1-info-custom section-1-info-custom-uniao">
            <div className="section-1-info-title section-1-info-title-custom">
              <h2>Boas-vindas</h2>
              <h3>à Assembleia Geral Ordinária 2026 Unicred Desbravadora</h3>
            </div>

            <p style={{ fontWeight: 500 }}>Sua participação fortalece nossa cooperativa.</p>
            <p>
              Aqui você confere os principais resultados, conquistas e avanços do exercício de 2025. Ao final da página, acesse o Edital de Convocação da Assembleia Geral Ordinária.
            </p>
          </div>
        </div>
      </div>

      <div className="section-2 without-selo">
        <h1 className="title-videos title-videos-desbra">Compromisso e transparência com os nossos cooperados.</h1>

        <div className="section-2-container wrap">
          <div className="section-2-info">
            <h1 className="title">Palavra do<span> Presidente</span></h1>
            <p>Conheça os principais destaques do exercício de 2025 na mensagem do presidente, Dr. Celso Marques Menezes.</p>
            <p style={{ marginTop: 30, fontSize: 22 }}>
              Caso tenha dúvidas ou deseje esclarecimentos adicionais, nossa equipe está à disposição.
            </p>
            <p style={{ marginTop: 12, fontSize: 22 }}>
              Entre em contato pelo e-mail: <a href="mailto:comunicacao.0544@unicred.com.br">comunicacao.0544@unicred.com.br</a>
            </p>
          </div>

          <div className="section-2-video">
            <div className="section-2-player">
              <video controls>
                <source src="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-desvravadora-2026-celso-marques-menezes.m4v" />
              </video>
            </div>
          </div>
        </div>
      </div>

      <div className="section-form" style={{ backgroundColor: "#332f2a" }}>
        <div className="wrap">
          <div className="section-info-uniao section-info-desbra">
            <h3>A Assembleia Geral da Unicred Desbravadora será transmitida em tempo real<br /> pelo App Unicred e pelo Internet Banking.</h3>
            <p style={{ marginBottom: 20 }}>
              Será transmitida do centro de eventos do Hotel Kindermann<br />
              Rua Romilda Tormem Gobbi, nº 250-D<br />
              Dom Gerônimo – Chapecó/SC
            </p>
            <p style={{ marginBottom: 20 }}>
              Data: 09 de março de 2026<br />
              Última chamada: 19h
            </p>
            <p>Cooperados de Chapecó/SC e região que desejarem acompanhar presencialmente serão bem-vindos.</p>
          </div>
        </div>
      </div>

      <div className="section-links" style={{ backgroundColor: "#3d3935" }}>
        <div className="section-links-container section-links-container-uniao wrap">
          <div>
            <ul className="links2" style={{ maxWidth: "100%" }}>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-desbravadora-demonstracoes-financeiras.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Demonstrações Financeiras - Relatório da Administração
                </a>
              </li>

              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/unicred-desbravadora-demonstracoes-financeiras-relatorio.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Demonstrações Financeiras - Com relatório do Auditor Independente
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/politica-de-conformidade.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Política de Conformidade
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/manual-unicred-web.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Tutorial de acesso computador
                </a>
              </li>
              <li>
                <a href="https://hallo-static.s3.sa-east-1.amazonaws.com/customers/unicred/2026/manual-unicred-mobile.pdf" target="_blank">
                  <span><img src={iconDownload} /></span>
                  Tutorial de acesso celular
                </a>
              </li>
            </ul>
          </div>

          <div className="section-links-info">
            <p>Converse com seu Gerente de Relacionamento ou envie sua dúvida para o e-mail <a href="mailto:comunicação.0544@unicred.com.br">comunicação.0544@unicred.com.br</a></p>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="footer-container wrap">
          <div className="footer-info">
            <a className="footer-info-site" href="https://unicred.com.br" target="_blank">unicred.com.br</a>

            <div className="footer-info-box"></div>
          </div>

          <div className="footer-social">
            <div className="footer-social-box">
              <h2>Siga a Unicred nas redes sociais</h2>
              <ul className="social-list">
                <li><a href="https://www.instagram.com/unicredbrasil/" title="Instagram" target="_blank"><img src={iconInstagram} alt="Instagram" /></a></li>
                <li><a href="https://www.facebook.com/unicredbrasil" title="Facebook" target="_blank"><img src={iconFacebook} alt="Facebook" /></a></li>
                <li><a href="https://twitter.com/unicredbrasil" title="Twitter" target="_blank"><img src={iconTwitter} alt="Twitter" /></a></li>
                <li><a href="https://www.youtube.com/channel/UCdowVMAIRENRC2VH0_gcdww" title="Youtube" target="_blank"><img src={iconYoutube} alt="Youtube" /></a></li>
                <li><a href="https://br.linkedin.com/company/unicredbr" title="Linkedin" target="_blank"><img src={iconLinkedin} alt="Linkedin" /></a></li>
              </ul>
            </div>

            <div className="footer-logo">
              <img src={unicredLogo} alt="Unicred" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnicredDesbravadora;
